export default {
  container: 'md:w-[136px] border-b-[2.8px] md:border-b-0 md:border-r-[2.8px] font-interMedium text-[16px] text-left',
  active: 'border-[#6AA12A] text-[#6AA12A]',
  inactive: 'border-transparent text-[#70747E]',
};
